import $ from 'jquery';
import 'slick-carousel';

function initSlider3() {
	let slides = $('.page-hero .slides');
	let firstSlide = $('.page-hero .slides .slide-1');

	slides.on('init', function () {
		firstSlide.find('.words').delay(1000).addClass('animate');
	});

	slides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(
			'.page-hero .slides .slick-slide[data-slick-index="' +
				nextSlide +
				'"] .words'
		)
			.delay(1000)
			.addClass('animate');
	});

	if (slides.length && slides.find('.slide-2').length) {
		slides.not('.slick-initialized').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: true,
			pauseOnHover: false,
			pauseonFocus: false,
			speed: 1000,
		});
	}
}

$(window).on('load', function () {
	initSlider3();
});
